import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { formatToUSD, rootUrl, sumArray } from '../../helpers';
import { useAuth } from '../../context/auth-context';
import { FaList } from 'react-icons/fa';

const CashierViewPaymentVouchers = () => {
  const [paymentVouchers, setPaymentVouchers] = useState([]);
  const [recs, setRecs] = useState([]);
  const [pvVisible, setPvVisible] = useState({});
  const [selectedPaymentType, setSelectedPaymentType] = useState('');

  const auth = useAuth();

  const fetchVouchers = async () => {
    try {
      const response = await axios.get(rootUrl(`/get-in-transits`));
      
      setRecs([...new Set(response.data.data.filter(a=>a.mode === 'Pending').map((res) => res.reciept))]);
      setPaymentVouchers(response.data.data.filter(a=>a.mode === 'Pending'));
      
    } catch (error) {
      console.error('Error fetching Payment Vouchers', error);
      toast.error('Failed to fetch Payment Vouchers');
    }
  };

  useEffect(() => {
    fetchVouchers();
  }, []);

  const togglePvVisibility = (reciept) => {
    setPvVisible((prev) => ({ ...prev, [reciept]: !prev[reciept] }));
  };

  const handlePayment = async (reciept) => {
    if (!selectedPaymentType) {
      toast.error('Please select a payment type');
      return;
    }

    try {
        const response = await axios.post(rootUrl('/pay'), {rec:reciept, uid:auth.user.id, paymentType:selectedPaymentType});
        toast.success(response.data.message);
        
      } catch (error) {
        console.error(error);
      }
    // Add logic here for processing the payment (e.g., API call)
    toast.success(`Payment for Voucher #${reciept} processed via ${selectedPaymentType}`);
  };

  return (
    <div className="container mx-auto p-4 shadow-lg rounded-lg">
      <div>
        <h2 className="text-xl font-bold flex items-center"> <FaList /> Payment Vouchers</h2>
      </div>
      <hr className='my-3' />

      {/* Payment Vouchers Section */}
      <div>
        {
            recs.length === 0?
            (
                "No pending payment vouchers"
            ):(
        recs.map((reciept) => (
          <div key={reciept} className="mb-4">
            <div
              className="cursor-pointer bg-gray-200 p-3 rounded-lg"
              onClick={() => togglePvVisibility(reciept)}
            >
              <span>Voucher #: {reciept}</span>
            </div>
            {pvVisible[reciept] && (
              <div className="border rounded-lg m-3 p-4">
                <div className="font-bold text-lg text-center">
                  <div className="flex justify-center">
                    <img src="/logo1.png" className="w-24" alt="Logo" />
                  </div>
                  <span>Ministry of Mines and Development</span>
                  <br />
                  <span>Payment Voucher</span>
                </div>

                <div>
                  Date: {paymentVouchers.filter((a) => a.reciept === reciept)[0].date.substring(0, 10)}
                </div>
                <div>
                  Seller: {paymentVouchers.filter((a) => a.reciept === reciept)[0].name}
                </div>

                <table className="min-w-full table-auto border-collapse border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left">Sno</th>
                      <th className="px-4 py-2 text-left">Description</th>
                      <th className="px-4 py-2 text-left">Weight(grams)</th>
                      <th className="px-4 py-2 text-left">Unit Price</th>
                      <th className="px-4 py-2 text-left">Total Amount ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentVouchers.filter((a) => a.reciept === reciept).map((pv, index) => (
                      <tr key={pv.id}>
                        <td className="px-4 py-2">{++index}</td>
                        <td className="px-4 py-2">Gold ({pv.type})</td>
                        <td className="px-4 py-2">$84</td>
                        <td className="px-4 py-2">{pv.weight}</td>
                        <td className="px-4 py-2">{formatToUSD(parseFloat(pv.weight) * 84)}</td>
                      </tr>
                    ))}

                    <tr className="font-bold">
                      <td className="px-4 py-2" colSpan={3}>Total</td>
                      <td className="px-4 py-2">
                        {sumArray(paymentVouchers.filter((a) => a.reciept === reciept).map((res) => parseFloat(res.weight)))}
                      </td>
                      <td className="px-4 py-2">
                        {formatToUSD(sumArray(paymentVouchers.filter((a) => a.reciept === reciept).map((res) => parseFloat(res.weight) * 84)))}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Payment Selection */}
                <div className="mt-4">
                  <label className="block text-sm font-medium">Select Payment Type:</label>
                  <select
                    className="mt-2 p-2 border border-gray-300 rounded"
                    value={selectedPaymentType}
                    onChange={(e) => setSelectedPaymentType(e.target.value)}
                  >
                    <option value="">-- Select --</option>
                    <option value="Cash">Cash</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Mobile Money">Mobile Money</option>
                  </select>

                  <button
                    className="mt-3 p-2 bg-blue-500 rounded ml-2 text-white rounded"
                    onClick={() => handlePayment(reciept)}
                  >
                    Pay
                  </button>
                </div>
              </div>
            )}
          </div>
        )))}
      </div>
    </div>
  );
};

export default CashierViewPaymentVouchers;
